import React, { useEffect, useState } from 'react'
//import { Footer } from '@govtechsg/sgds-react'
import { Helmet } from "react-helmet-async";

// Components
import HeaderRegComponent from '../../Components/HeaderRegComponent'
import FooterComponent from '../../Components/FooterComponent'

import workshopImage from '../../images/blog/workshop_may_2025.jpeg';
import workshopSepImage from '../../images/blog/workshop_sep_2025.jpeg';
import apiBestPractice from '../../images/blog/api_best_practice.png';

const Blog = () => { 
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const cardStyle = {
        boxShadow: '0 4px 8px 3px rgba(60, 64, 67, .15), 0 1px 3px 0 rgba(60, 64, 67, .3)',
        padding: '40px 20px',
        borderRadius: '20px',
        marginBottom: '30px',
        transition: 'all 0.3s ease',
    };

    const hoveredCardStyle = {
        ...cardStyle,
        boxShadow: '0 8px 16px 6px rgba(60, 64, 67, .2), 0 2px 6px 0 rgba(60, 64, 67, .4)',
        transform: 'translateY(-5px)',
        cursor: 'pointer',
    };

  	return (
		<>
		<Helmet>
        <title>Blog | OneMap API</title>
        <meta
          name="description"
          content="OneMap Blog to share best practice and code snippets to use OneMap API"
        />
      </Helmet>
		<div className="om-body container-fluid">

			<HeaderRegComponent />

			<div className="om-body-content pageBase">
                <div className='blog center om-body-container'>
                    <div className='row mb-4'>
                        <div class="col-md-10 offset-md-1" style={{minHeight:'50vh'}}>
                        <ul style={{listStyleType: 'none'}}>

                        <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/workshopaug2025`}>
                            <li 
                                style={hoveredIndex === 1 ? hoveredCardStyle : cardStyle}
                                onMouseEnter={() => setHoveredIndex(1)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                <div className="row align-items-center">
                                    <div className="col-md-4 col-12 mb-3 mb-md-0">
                                        <img className="img-fluid w-100" src={workshopSepImage} alt='intro' />
                                    </div>
                                    <div className="col-md-8 col-12">
                                        <h2>
                                            OneMap Workshop – August 2025
                                        </h2>
                                        <p>Adapting Geospatial Technologies into Meaningful Features. Singapore Land Authority conducted another successful iteration of the OneMap Workshop in August 2025, bringing together officers from government agencies, private sector professionals, and learners interested in OneMap's suite of APIs.... <a aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/workshopaug2025`}>Read More</a></p>
                                    </div>
                                </div>
                            </li>
                        </a>

                        <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/verifyingsearchapitoken`}>
                            <li 
                                style={hoveredIndex === 2 ? hoveredCardStyle : cardStyle}
                                onMouseEnter={() => setHoveredIndex(2)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                <div className="row align-items-center">
                                    <div className="col-md-4 col-12 mb-3 mb-md-0">
                                    <img className="img-fluid w-100" src={apiBestPractice} alt='intro' />
                                    </div>
                                    <div className="col-md-8 col-12">
                                        <h2>
                                        Verifying Search API Token Implementation
                                        </h2>
                                        <p>Search API requests must include a valid API token in the Authorization header.<br/><a aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/verifyingsearchapitoken`}>Read More</a></p>
                                    </div>
                                </div>
                            </li>
                        </a>
                        
                        <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/jwttokenupdate`}>
                                <li 
                                    style={hoveredIndex === 3 ? hoveredCardStyle : cardStyle}
                                    onMouseEnter={() => setHoveredIndex(3)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <div className="row align-items-center">
                                        <div className="col-md-4 col-12 mb-3 mb-md-0">
                                        <img className="img-fluid w-100" src={apiBestPractice} alt='intro' />
                                        </div>
                                        <div className="col-md-8 col-12">
                                            <h2>
                                            Migration from HS256 to RS256 for JWT Signing
                                            </h2>
                                            <p>We have migrated the JWT signing algorithm used for authenticating access to OneMap endpoints from HS256 to RS256. <a aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/jwttokenupdate`}>Read More</a></p>
                                        </div>
                                    </div>
                                </li>
                            </a>

                            <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/workshopmay2025`}>
                                <li 
                                    style={hoveredIndex === 4 ? hoveredCardStyle : cardStyle}
                                    onMouseEnter={() => setHoveredIndex(4)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <div className="row align-items-center">
                                        <div className="col-md-4 col-12 mb-3 mb-md-0">
                                            <img className="img-fluid w-100" src={workshopImage} alt='intro' />
                                        </div>
                                        <div className="col-md-8 col-12">
                                            <h2>
                                                OneMap Workshop – May 2025
                                            </h2>
                                            <p>Unlocking the Power of Geospatial Data for Government and Businesses
                                    In May 2025, the Singapore Land Authority (SLA) hosted the OneMap Workshop bringing together participants from various government agencies and private sector
                                    organizations.... <a aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/workshopmay2025`}>
                                                                Read More</a></p>
                                        </div>
                                    </div>
                                </li>
                            </a>

                                
                            <a className='nav-link px-0' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/tokenmanagement`}>
                            <li 
                                style={hoveredIndex === 5 ? hoveredCardStyle : cardStyle}
                                onMouseEnter={() => setHoveredIndex(5)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                
                                <div className="row align-items-center">
                                    <div className="col-md-4 col-12 mb-3 mb-md-0">
                                        <img className="img-fluid w-100" src={apiBestPractice} alt='intro' />
                                    </div>
                                    <div className="col-md-8 col-12">
                                        <h2>
                                                Managing and Refreshing OneMap Token Validity in NodeJS
                                        </h2>
                                        <p>
                                            The OneMap API requires a valid access token for each API request, and tokens need to be refreshed every 72 hours. This tutorial will guide you through the steps to properly authenticate and handle API requests in NodeJS... 
                                        </p>
                                    </div>
                                </div>
                            </li>
                            </a>
                        </ul>
 
                    </div>
                </div>
            </div>
        </div>

			<FooterComponent />

		</div>
		</>
	)
}

export default Blog